export function parseProxyEvent(message) {
    if (message == null || typeof message !== 'object') return null;
    const m = message;
    if (m.source !== 'yt-proxy' || typeof m.event !== 'string') return null;
    return {
        event: m.event,
        data: m.data
    };
}
export function stateToAction(state) {
    if (state === 1) return 'play';
    if (state === 2) return 'pause';
    return null;
}
export function thumbnailUrl(videoId) {
    return "https://i.ytimg.com/vi/".concat(videoId, "/hqdefault.jpg");
}
